module.exports = __webpack_public_path__ + "static/media/centenarioUldaHD.836c6ed2.mp4";